<div class="app-home-strategy">
  <div class="strategy-header">
    <div>
      <h2 class="ds-heading-2">{{ 'PERFORMANCE.contentSwitcher.strategy.allocation.title' | translate }}</h2>
      <ion-icon name="info2" (click)="toggleInfo('strategyTitle')"></ion-icon>
    </div>
    <p class="ds-ui-3 ds-color-core-neutral-7" *ngIf="showElements['strategyTitle']">
      @if (isEve2) {
        {{ 'PERFORMANCE.contentSwitcher.strategyEve2.allocation.info' | translate }}
      } @else {
        {{ 'PERFORMANCE.contentSwitcher.strategy.allocation.info' | translate }}
      }
    </p>
  </div>
  <div class="allocation" *ngIf="portfolioAllocation">
    <app-ds-allocation-bar
      [allocationItems]="[portfolioAllocation.stocks, portfolioAllocation.stability, portfolioAllocation.bonds, portfolioAllocation.cash]"
      [customColors]="['var(--color-core-brand-4-2)', 'var(--color-core-brand-6-2)', 'var(--color-core-brand-2-2)', 'var(--color-core-neutral-3)']"
    ></app-ds-allocation-bar>

    <div class="legend" *ngIf="portfolioAllocation.stocks.percentage">
      <app-ds-legend color="custom" customColor="var(--color-core-brand-4-3)">
        <span class="ds-ui-3 ds-color-core-neutral-7">
          {{
            'PERFORMANCE.contentSwitcher.strategy.allocation.legend.impactStocksLabel'
              | translate
                : {
                    value: (portfolioAllocation.stocks.percentage | percent: '1.0-0')
                  }
          }}
        </span>
      </app-ds-legend>
      <p class="ds-caption-2">{{ portfolioAllocation.stocks.value | thousand: currency }}</p>
    </div>

    <div class="legend" *ngIf="portfolioAllocation.stability.percentage">
      <app-ds-legend color="custom" customColor="var(--color-core-brand-6-3)">
        <span class="ds-ui-3 ds-color-core-neutral-7">
          {{
            'PERFORMANCE.contentSwitcher.strategy.allocation.legend.stabilityStocksLabel'
              | translate: { value: (portfolioAllocation.stability.percentage | percent: '1.0-0') }
          }}
        </span>
      </app-ds-legend>
      <p class="ds-caption-2">{{ portfolioAllocation.stability.value | thousand: currency }}</p>
    </div>

    <div class="legend" *ngIf="portfolioAllocation.bonds.value">
      <app-ds-legend color="custom" customColor="var(--color-core-brand-2-2)">
        <span class="ds-ui-3 ds-color-core-neutral-7">
          {{
            'PERFORMANCE.contentSwitcher.strategy.allocation.legend.bondsLabel'
              | translate: { value: (portfolioAllocation.bonds.percentage | percent: '1.0-0') }
          }}
        </span>
      </app-ds-legend>
      <p class="ds-caption-2">{{ portfolioAllocation.bonds.value | thousand: currency }}</p>
    </div>

    <div class="legend" *ngIf="portfolioAllocation.cash.value">
      <app-ds-legend color="custom" customColor="var(--color-core-neutral-3)">
        <span class="ds-ui-3 ds-color-core-neutral-7">
          {{
            'PERFORMANCE.contentSwitcher.strategy.allocation.legend.cashLabel'
              | translate: { value: (portfolioAllocation.cash.percentage | percent: '1.0-0') }
          }}
        </span>
      </app-ds-legend>
      <p class="ds-caption-2">{{ portfolioAllocation.cash.value | thousand: currency }}</p>
    </div>
  </div>
  <!-- Eve2 Portfolio Allocation-->
  <div class="allocation" *ngIf="portfolioAllocationV2">
    @if (portfolioAllocationV2.migration_in_progress) {
      <app-ds-callout
        variant="info"
        [title]="'PERFORMANCE.contentSwitcher.strategy.allocation.migration.title' | translate"
        [description]="'PERFORMANCE.contentSwitcher.strategy.allocation.migration.desc' | translate"
      ></app-ds-callout>
    } @else {
      <app-ds-allocation-bar
        [allocationItems]="[
          { percentage: portfolioAllocationV2.fund_percentage, value: portfolioAllocationV2.fund_amount },
          { percentage: portfolioAllocationV2.bond_percentage, value: portfolioAllocationV2.bond_amount },
          { percentage: portfolioAllocationV2.cash_percentage, value: portfolioAllocationV2.cash_amount }
        ]"
        [customColors]="['var(--color-core-brand-4-2)', 'var(--color-core-brand-2-2)', 'var(--color-core-neutral-3)']"
      ></app-ds-allocation-bar>

      <div class="legend" *ngIf="portfolioAllocationV2.fund_amount">
        <app-ds-legend color="custom" customColor="var(--color-core-brand-4-3)">
          <span class="ds-ui-3 ds-color-core-neutral-7">
            {{
              'PERFORMANCE.contentSwitcher.strategy.allocation.legend.etf'
                | translate
                  : {
                      value: (portfolioAllocationV2.fund_percentage | percent: '1.0-0')
                    }
            }}
          </span>
        </app-ds-legend>
        <p class="ds-caption-2">{{ portfolioAllocationV2.fund_amount | thousand: currency }}</p>
      </div>

      <div class="legend" *ngIf="portfolioAllocationV2.bond_amount">
        <app-ds-legend color="custom" customColor="var(--color-core-brand-2-2)">
          <span class="ds-ui-3 ds-color-core-neutral-7">
            {{
              'PERFORMANCE.contentSwitcher.strategy.allocation.legend.bondsLabel'
                | translate: { value: (portfolioAllocationV2.bond_percentage | percent: '1.0-0') }
            }}
          </span>
        </app-ds-legend>
        <p class="ds-caption-2">{{ portfolioAllocationV2.bond_amount | thousand: currency }}</p>
      </div>

      <div class="legend" *ngIf="portfolioAllocationV2.cash_amount">
        <app-ds-legend color="custom" customColor="var(--color-core-neutral-3)">
          <span class="ds-ui-3 ds-color-core-neutral-7">
            {{
              'PERFORMANCE.contentSwitcher.strategy.allocation.legend.cashLabel'
                | translate: { value: (portfolioAllocationV2.cash_percentage | percent: '1.0-0') }
            }}
          </span>
        </app-ds-legend>
        <p class="ds-caption-2">{{ portfolioAllocationV2.cash_amount | thousand: currency }}</p>
      </div>
    }
  </div>
  <p class="ds-heading-2">{{ 'PERFORMANCE.contentSwitcher.strategy.portfolioDetails.title' | translate }}</p>
  <div class="ds-rows-white">
    <div class="ds-row-white">
      <div class="content">
        <p class="ds-ui-2">{{ 'PERFORMANCE.contentSwitcher.strategy.portfolioDetails.strategy.name' | translate }}</p>
        <div>
          <p class="ds-ui-2">{{ 'STRATEGY.estimate.risk.' + homeStrategyDetails.riskLevel | translate }}</p>
          <ion-icon name="info2" (click)="toggleInfo('strategy')"></ion-icon>
        </div>
      </div>
      <div *ngIf="showElements['strategy']" class="info">
        <p class="ds-ui-3">{{ 'PERFORMANCE.contentSwitcher.strategy.portfolioDetails.strategy.info' | translate }}</p>
      </div>
    </div>

    <div class="ds-row-white">
      <div class="content">
        <p class="ds-ui-2">{{ 'PERFORMANCE.contentSwitcher.strategy.portfolioDetails.nextPortfolioReview.name' | translate }}</p>
        <div>
          @if (isEve2 && kind === '3a') {
            <p class="ds-ui-2 ion-text-end">{{ get3aPortfolioReviewDay() | translate }}</p>
          } @else {
            <p class="ds-ui-2 ion-text-end">{{ getDaysKey() | translate: { days: getDays() } }}</p>
          }

          <ion-icon name="info2" (click)="toggleInfo('review')"></ion-icon>
        </div>
      </div>
      <div *ngIf="showElements['review']" class="info">
        @if (isEve2) {
          <p class="ds-ui-3">{{ 'PERFORMANCE.contentSwitcher.strategyEve2.portfolioDetails.nextPortfolioReview.info' | translate }}</p>
        } @else {
          <p class="ds-ui-3">{{ 'PERFORMANCE.contentSwitcher.strategy.portfolioDetails.nextPortfolioReview.info' | translate }}</p>
        }
      </div>
    </div>

    <div class="ds-row-white" *ngIf="homeStrategyDetails.nextStrategyChangeAt">
      <div class="content">
        <p class="ds-ui-2">{{ 'PERFORMANCE.contentSwitcher.strategy.portfolioDetails.strategyChange.name' | translate }}</p>
        <div>
          <ng-container *ngIf="remainingTime.days === 0 && remainingTime.hours === 0; else showRemaining">
            <a
              class="ds-ui-2 ion-text-end"
              routerLink="/tabs/account/strategy/change-strategy"
              (click)="amplitudeTrack('Strategy Change Started', { kind: kind })"
            >
              {{ 'PERFORMANCE.contentSwitcher.strategy.portfolioDetails.strategyChange.now' | translate }}
            </a>
          </ng-container>
          <ng-template #showRemaining>
            <p class="ds-ui-2 ion-text-end">
              {{ getStrategyChangeRemaingDays() | translate: { days: remainingTime.days, months: remainingTime.months } }}
            </p>
          </ng-template>
          <ion-icon name="info2" (click)="toggleInfo('strategyChange')"></ion-icon>
        </div>
      </div>
      <div *ngIf="showElements['strategyChange']" class="info">
        <p
          class="ds-ui-3"
          routerLink="/tabs/account/strategy/change-strategy"
          [innerHTML]="'PERFORMANCE.contentSwitcher.strategy.portfolioDetails.strategyChange.info' | translate"
        ></p>
      </div>
    </div>
  </div>

  <app-ds-feedback-loop feedbackSource="Strategy" (trackFeedback)="onTrackFeedback($event)">
    {{ 'feedbackLoopWidget.title' | translate }}
  </app-ds-feedback-loop>
</div>
